import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveTab,
  setActiveFooterTab,
  showSideBar,
} from "../../store/actions";
import { withRouter } from "react-router-dom";
import { setBets } from "../../store/Betslip/actions";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import BookingCodeSheet from "./BookingCodeSheet";
import { useTranslation } from "react-i18next";

/* ── RN CustomTabBar SVG icons (ported from betyakata-mobile AppNavigator) ── */
const HomeIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
    <path
      d="M2.5 9.16667L10 2.5L17.5 9.16667"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16669 7.9165V17.4998H15.8334V7.9165"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 17.4998V11.6665H12.5V17.4998"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LiveTabIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      fill={color}
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16669 9.99984C4.16669 8.45274 4.78127 6.96901 5.87523 5.87505C6.96919 4.78109 8.45292 4.1665 10 4.1665M15.8334 9.99984C15.8334 11.5469 15.2188 13.0307 14.1248 14.1246C13.0308 15.2186 11.5471 15.8332 10 15.8332M7.08335 7.08317C6.31991 7.86204 5.89228 8.9092 5.89228 9.99984C5.89228 11.0905 6.31991 12.1376 7.08335 12.9165M12.9167 12.9165C13.6801 12.1376 14.1078 11.0905 14.1078 9.99984C14.1078 8.9092 13.6801 7.86204 12.9167 7.08317"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SlipIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
    <path
      d="M4.16669 2.5H15.8334V17.5L13.3334 15.8333L11.6667 17.5L10 15.8333L8.33335 17.5L6.66669 15.8333L4.16669 17.5V2.5Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 6.6665H12.5M7.5 9.99984H12.5M7.5 13.3332H10.8333"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MyBetsIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
    <path
      d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.8335V10.0002L12.5 11.6668"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UserIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="1.5" />
    <path
      d="M20 21C20 17.134 16.866 14 12 14C7.134 14 4 17.134 4 21"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

function Footer(props) {
  const { t } = useTranslation();
  const isLoggedIn = sessionStorage.getItem("token") ? true : false;
  const activeTab = useSelector(
    (state) => state?.CommonState?.activeTab ?? false
  );
  const activeFooterTab = useSelector(
    (state) => state?.CommonState?.activeFooterTab ?? false
  );

  const Bets = useSelector((state) => state?.Betslip?.bets ?? []);

  const dispatch = useDispatch();

  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  useEffect(() => {
    const storedBets = localStorage.getItem("betsplace");
    if (storedBets) {
      dispatch(setBets(JSON.parse(storedBets)));
    }
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("betsplace", JSON.stringify(Bets));
  }, [Bets]);

  const handleTawkLoad = () => {
    if (window.innerWidth <= 1000 && window.Tawk_API?.hideWidget) {
      window.Tawk_API.hideWidget();
    }
  };

  const [isFullscreen, setIsFullscreen] = React.useState(false);

  // Watch for fullscreenchange
  React.useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener("fullscreenchange", onFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  const pathname = props.location?.pathname ?? window.location.pathname;

  /* RN CustomTabBar: Home / Live / Slip / My Bets / Profile */
  const tabs = [
    {
      key: "home",
      label: t("footer_home", "Home"),
      Icon: HomeIcon,
      isActive:
        pathname === "/sports" && ["home-upcoming"].includes(activeTab),
      onPress: () => {
        dispatch(setActiveFooterTab("home"));
        dispatch(setActiveTab("home-upcoming"));
        props.history.push("/sports");
      },
    },
    {
      key: "live",
      label: t("footer_live", "Live"),
      Icon: LiveTabIcon,
      isActive:
        pathname === "/sports" && ["home-live-now"].includes(activeTab),
      onPress: () => {
        props.history.push("/sports");
        dispatch(setActiveTab("home-live-now"));
        dispatch(setActiveFooterTab("home-live-now"));
      },
    },
    {
      key: "betslip",
      label: t("footer_slip_tab", "Slip"),
      Icon: SlipIcon,
      badge: Bets.length,
      isActive: pathname.toLowerCase() === "/betslip",
      onPress: () => {
        if (Bets.length > 0) {
          dispatch(setActiveFooterTab("betslip"));
          props.history.push("/betSlip");
        } else {
          // RN behavior: empty slip opens the booking-code sheet instead of navigating
          setIsBookingModalOpen(true);
        }
      },
    },
    {
      key: "my-bets",
      label: t("footer_my_bets", "My Bets"),
      Icon: MyBetsIcon,
      isActive: pathname === "/MyBets",
      onPress: () => {
        dispatch(setActiveFooterTab("my-bets"));
        dispatch(setActiveTab(""));
        props.history.push(isLoggedIn ? "/MyBets" : "/login");
      },
    },
    {
      key: "profile",
      label: t("side_menu_profile", "Profile"),
      Icon: UserIcon,
      isActive: false,
      onPress: () => {
        // RN behavior: Profile tab opens the side drawer instead of navigating
        dispatch(showSideBar(true));
      },
    },
  ];

  return (
    <>
      <div className="BLM-mobile-footer w-full !bg-[#0f1923] !border-t !border-[#252838] px-0 lg:hidden">
        <ul className="!flex w-full justify-around !bg-[#0f1923] pt-[10px] pb-[6px]">
          {tabs.map(({ key, label, Icon, badge, isActive, onPress }) => {
            const color = isActive ? "var(--bet-header-accent)" : "#6b7280";
            return (
              <li
                key={key}
                onClick={onPress}
                className="flex-1 !flex flex-col items-center gap-[3px] !bg-transparent cursor-pointer"
              >
                <div className="relative">
                  <Icon size={22} color={color} />
                  {key === "betslip" && badge > 0 && (
                    <span className="absolute -top-1 -right-2 min-w-[16px] h-4 rounded-full bg-[var(--bet-header-accent)] text-black text-[9px] font-extrabold flex items-center justify-center px-[3px]">
                      {badge}
                    </span>
                  )}
                </div>
                <div
                  className="text-[10px] font-bold leading-none truncate w-full text-center"
                  style={{ color }}
                >
                  {label}
                </div>
                <span
                  className="w-1 h-1 rounded-full"
                  style={{
                    backgroundColor: isActive ? "var(--bet-header-accent)" : "transparent",
                  }}
                />
              </li>
            );
          })}
        </ul>
      </div>

      <BookingCodeSheet
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
      />

      <div
        style={
          isFullscreen
            ? {
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 9999,
                background: "white",
              }
            : {}
        }
      >
        <TawkMessengerReact
          propertyId="601ab7aaa9a34e36b973716b"
          widgetId="1etk5qsn0"
          onLoad={handleTawkLoad}
        />
      </div>
    </>
  );
}

export default withRouter(Footer);
